@import '../../../globals/main.scss';

pn-find-service-and-price-result {
}
